import React from 'react';
import { useSelector } from 'react-redux';

import { Form, Select, DatePicker, ListHorizontal } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import { formatDate, currencyFormat } from 'utilities/common';
import _ from 'underscore'

const typeOptions = [
  { value: 'direct_journal', label: 'Direct Journal' },
  { value: 'transaction', label: 'Transaksi' },
];

const initialState = {
  transaction: null,
  partner: null,
  selectedType: { value: 'direct_journal', label: 'Direct Journal' },
  ref_code: '',
  entry_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  note: '',
  totalCredit: null,
  totalDebit: null,
  is_adjustment: false,
};

export const FormGeneral = ({
  data,
  onChange,
  isLoading,
  items
}) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    {
      transaction,
      partner,
      selectedType,
      ref_code,
      entry_at,
      note,
      totalCredit,
      totalDebit,
      is_adjustment
    },
    setState,
  ] = React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const $handlePartner = async (e) => {
    setState((prevState) => ({
      ...prevState,
      partner: e,
    }));
  };

  const $handleTransaction = async (e) => {
    setState((prevState) => ({
      ...prevState,
      transaction: e,
    }));
  };

  React.useEffect(() => {
    const state = {
      transaction,
      partner,
      type: selectedType?.value,
      ref_code,
      entry_at,
      note,
      is_adjustment
    };

    onChange(state);
  }, [
    transaction,
    partner,
    selectedType,
    ref_code,
    entry_at,
    note,
    is_adjustment,
  ]);

  React.useEffect(() => {
    if (!data) return;

    let ot = null
    _.each(typeOptions, (t) => {
      if (t?.value === data?.type) {
        ot = t
      }
    })

    setState((prevState) => ({
      ...prevState,
      transaction: data?.transaction,
      partner: data?.partner,
      selectedType: ot,
      ref_code: data?.ref_code,
      entry_at: {
        default: new Date(data?.entry_date),
        formatted: formatDate(data?.entry_date, 'YYYY-MM-DD'),
      },
      note: data?.note,
      is_adjustment: data?.is_adjustment
    }));
  }, [data]);

  React.useEffect(() => {
    let cc = 0
    let cd = 0
    _.each(items, (i) => {
      if (i?.type === 'credit') {
        cc += i?.nominal
      }

      if (i?.type === 'debit') {
        cd += i?.nominal
      }

      setState((prevState) => ({...prevState, totalCredit: cc, totalDebit: cd}));
    })
  }, [items])

  return (
    <div className='mt-3 border-bottom'>
      {isLoading ? (
        <div className="row border-bottom">
          {dummy?.map((d, i) => (
            <div className="col-md-6" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      ) : (
        <div className='row'>
          <div className='col-6'>
            <div className="mb-3">
              <label className='form-label required'>Tipe</label>
              <Select
                isClearable
                classNamePrefix={
                  StateForm?.errors?.type ? 'is-invalid' : 'select'
                }
                placeholder=""
                value={selectedType}
                options={typeOptions}
                onChange={(e) =>
                  setState((prevState) => ({...prevState, selectedType: e}))
                }
                error={StateForm?.errors?.type}
              />

              {StateForm?.errors?.type ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.type}
                </div>
              ) : null}
            </div>

            {selectedType?.value === 'transaction' && (
              <div className="mb-3">
                <Select.Remote
                  required
                  label="Pilih Transaksi"
                  placeholder=""
                  url="/accounting/transaction"
                  initialValue={transaction?.id}
                  keys={transaction?.id}
                  row={(d) => {
                    return { value: d.id, label: d.name };
                  }}
                  onSelected={(c) => {
                    $handleTransaction(c);
                  }}
                  errors={StateForm?.errors?.transaction_id}
                />
              </div>
            )}

            <div className="mb-3">
              <Select.Remote
                label="Pilih Client"
                placeholder=""
                url="/partner"
                initialValue={partner?.id}
                keys={partner?.id}
                row={(d) => {
                  return { value: d.id, label: d.name };
                }}
                onSelected={(c) => {
                  $handlePartner(c);
                }}
                errors={StateForm?.errors?.partner_id}
              />
            </div>

            <div className="mb-3">
              <Form.Checkbox
                onChange={() => {
                  if (!is_adjustment) {
                    setState((prevState) => ({
                      ...prevState,
                      is_adjustment: true,
                    }));
                  } else {
                    setState((prevState) => ({
                      ...prevState,
                      is_adjustment: false,
                    }));
                  }
                }}
                iconSize={18}
                value={is_adjustment}
                label="Journal Penyesuaian"
              />
            </div>

            {totalCredit !== totalDebit && (
              <div className="mb-3">
                <ListHorizontal
                  className="border-0"
                  title="Nominal Selisih"
                  content={currencyFormat(totalDebit - totalCredit)}
                />

                {StateForm?.errors?.selisih ? (
                  <div className="invalid-feedback" style={{ display: 'block' }}>
                    {StateForm?.errors?.selisih}
                  </div>
                ) : null}
              </div>
            )}
          </div>
          <div className='col-6'>
            <Form.Input
              label="No. Referensi"
              type="text"
              value={ref_code}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  ref_code: e.target.value,
                }))
              }
              error={StateForm?.errors?.ref_code}
            />
            <div className="mb-3">
              <label className="form-label required">Tanggal Journal</label>
              <div
                className={
                  StateForm?.errors?.entry_at ? 'border border-danger rounded' : ''
                }
              >
                <DatePicker
                  type="normal"
                  value={entry_at?.default || null}
                  format="dd/MM/yyyy"
                  onChange={(date) => {
                    setState((prevState) => ({
                      ...prevState,
                      entry_at: {
                        default: date,
                        formatted: formatDate(date, 'YYYY-MM-DD'),
                      },
                    }));
                  }}
                  isShowTrigger
                  error={StateForm?.errors?.entry_at}
                />
              </div>

              {StateForm?.errors?.entry_at ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.entry_at}
                </div>
              ) : null}
            </div>

            <Form.Textbox
              label="Keterangan"
              type="text"
              value={note}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  note: e.target.value,
                }))
              }
              error={StateForm?.errors?.note}
            />
          </div>
        </div>
      )}
    </div>
  );
};
